import CONSTANT from "../../constants/constant";
import useQueueStore from "../../stores/queueStore";
import Button from "../Button";
import Icon from "../Icon/Icon";
import MessageModal from "../MessageModal";
import QueueCard from "../QueueCard";
import Paragraph from "../Utils/Paragraph.styled";
import Stack from "../Utils/Stack.styled";
import Title from "../Utils/Title.styled";
import { QueueContainer, QueueDetails, QueueHeader } from "./Queue.styled";
import { useState } from "react";
import { motion } from "framer-motion";

const Queue = () => {
  const currentQueues = useQueueStore((state) => state.currentQueues);
  const clearQueue = useQueueStore((state) => state.clearQueue);
  const updateQueueStatus = useQueueStore((state) => state.updateQueueStatus);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [isFullVersion, setIsFullVersion] = useState(true);
  const renderQueueCard = (it, i) => {
    return (
      <QueueCard
        key={i}
        thumbnailUrl={it.thumbnailUrl}
        title={it.title}
        isPlayingNow={it.isPlayingNow}
        onClick={() => updateCurrentPlaying(i)}
      />
    );
  };

  const updateCurrentPlaying = (i) => {
    const currentPlayingIndex = getCurrentPlayingIndex();
    if (currentPlayingIndex !== -1) {
      updateQueueStatus(currentPlayingIndex, false);
    }
    updateQueueStatus(i, true);
  };

  const onClickClearQueue = () => {
    setShowMessageModal(true);
  };

  const getButtonStatus = (key) => {
    if (key === CONSTANT.LABEL.CONFIRM) {
      clearQueue();
    }
    setShowMessageModal(false);
  };

  const onClickCheckQueueScreen = () => {
    setIsFullVersion(!isFullVersion);
  };

  const getCurrentPlayingIndex = () => {
    return currentQueues.findIndex((it) => it.isPlayingNow);
  };

  if (currentQueues.length > 0)
    return (
      <QueueContainer>
        <QueueHeader isFullVersion={isFullVersion}>
          <Stack direction="column" gap="16">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center">
                <Title size="20px" style={{ fontWeight: "900" }}>
                  Queue
                </Title>
                <Paragraph size="14px">
                  {getCurrentPlayingIndex() + 1}/{currentQueues.length}
                </Paragraph>
              </Stack>

              <div
                style={{ cursor: "pointer" }}
                onClick={onClickCheckQueueScreen}
              >
                <Icon
                  size="24px"
                  type={
                    isFullVersion
                      ? CONSTANT.ICON.CLOSE
                      : CONSTANT.ICON.DOWN_ARROW
                  }
                ></Icon>
              </div>
            </Stack>
            {isFullVersion && (
              <Stack direction="row" justifyContent="space-between">
                <Button
                  fontSize="14px"
                  padding="0"
                  background="transparent"
                  hoverColor="black"
                  defaultColor="black"
                  label={CONSTANT.ICON.ADD_TO_PLAYLIST}
                  type={CONSTANT.ICON.ADD_TO_PLAYLIST}
                />
                <Paragraph
                  size="14px"
                  style={{ cursor: "pointer" }}
                  onClick={onClickClearQueue}
                >
                  Clear
                </Paragraph>
              </Stack>
            )}
          </Stack>
        </QueueHeader>
        {isFullVersion && (
          <QueueDetails
            as={motion.div}
            key="details"
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          >
            {currentQueues.map((it, i) => renderQueueCard(it, i))}
          </QueueDetails>
        )}
        {showMessageModal && (
          <MessageModal
            title={CONSTANT.ERROR.QUEUE_TITLE}
            message={CONSTANT.ERROR.QUEUE_MESSAGE}
            onClick={getButtonStatus}
            showConfirmButton
          />
        )}
      </QueueContainer>
    );
};

export default Queue;
